import { motion } from 'framer-motion';

function PageHero({ eyebrow, title, accent, text, image }) {
  return (
    <section className="relative isolate overflow-hidden bg-ink text-white">
      <img src={image} alt="" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-45" />
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-ink via-ink/75 to-transparent" />
      <div className="wrap py-24 md:py-36">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="eyebrow !text-clay">{eyebrow}</p>
          <h1 className="h-display mt-6 max-w-3xl text-6xl md:text-8xl">
            {title} <em className="text-clay">{accent}</em>
          </h1>
          <p className="mt-8 max-w-xl text-base leading-8 text-white/75">{text}</p>
        </motion.div>
      </div>
    </section>
  );
}

export default PageHero;
